<script setup lang="ts">
/**
 *
 *  Props and emits section
 *
 *
 */

defineProps<{
    color?: string
    size?: string
    width?: string
    height?: string
}>()

/**
 *
 *  Ref, computed and hooks section
 *
 *
 */

/**
 *
 *  Life cicle events
 *
 *
 */

/**
 *
 *  Functions section
 *
 *
 */
</script>

<template>
    <svg
        :width="size ? size : width ? width : 20"
        :height="size ? size : height ? height : 20"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M7.5 20C6.125 20 5.0125 21.125 5.0125 22.5C5.0125 23.875 6.125 25 7.5 25C8.875 25 10 23.875 10 22.5C10 21.125 8.875 20 7.5 20ZM0 0V2.5H2.5L7 11.9875L5.3125 15.05C5.1125 15.4 5 15.8125 5 16.25C5 17.625 6.125 18.75 7.5 18.75H22.5V16.25H8.025C7.85 16.25 7.7125 16.1125 7.7125 15.9375L7.75 15.7875L8.875 13.75H18.1875C19.125 13.75 19.95 13.2375 20.375 12.4625L24.85 4.35C24.95 4.175 25 3.9625 25 3.75C25 3.0625 24.4375 2.5 23.75 2.5H5.2625L4.0875 0H0ZM20 20C18.625 20 17.5125 21.125 17.5125 22.5C17.5125 23.875 18.625 25 20 25C21.375 25 22.5 23.875 22.5 22.5C22.5 21.125 21.375 20 20 20Z"
            :fill="color || '#BFBFBF'"
            class="path_fill"
        />
    </svg>
</template>

<style scoped></style>
